const flights = {
  flight: "Flight",
  flights: "Flights",
  originDepartureDate: "Departure",
  destinationDepartureDate: "Return",
  outbound: "Outbound",
  inbound: "Inbound",
  travelTime: "Travel time",
  selected: "selected",
  select: "select",
  airline: "Airline",
  directFlight: "Direct flight",
  baggage: "Baggage",
  stops: "Stops",
  nonStop: "Non-stop",
  oneStopMax: "One stop max",
  twoStopsMax: "Two stops max",
  anyStops: "With any stops",
  smallBaggage: "Small baggage",
  bigBaggage: "Big baggage",
  smallAndBigBaggage: "Small and big baggage",
  outboundStops: "Outbound stops",
  inboundStops: "Inbound stops",
  selectAirline: "Select Airline",
  baggageOption: "Baggage option",
  outboundDepartureAfter: "Outbound departure after",
  outboundArrivalAfter: "Outbound arrival after",
  inboundDepartureAfter: "Inbound departure after",
  inboundArrivalTimeAfter: "Inbound arrival after",
  flightClass: "Flight class",
  outboundDepAfter: "Out departure after",
  outboundArrivalAfrer: "Out arrival after",
  inboundDepAfter: "In departure after",
  inboundArrivalAfter: "In arrival after",
  airlines: "Airline(s)",
  lessThan: "Less than",
  layover: "Layover",
  duration: "Duration",
  noClassPreference: "No Class Preference",
  economy: "Economy",
  business: "Business",
  with: "With",
  without: "Without",
  twoOrMore: "Two or more",
  departure: "Departure",
  return: "Return",
  submit: "Submit",
  priceLessThan: "Price less than",
  durationLessThan: "Duration less than",
  layoverLessThan: "Layover less than",
  noLayover: "No layover",
  durationLowestFirst: "Duration (lowest first)",
  durationHighestFirst: "Duration (highest first)",
  idType: "ID Type",
  idPassportCode: "ID/Passport Code",
  expirationDate: "Expiration Date",
  frequentFlyerNumber: "Frequent Flyer Number",
  frequentFlyerAirline: "Frequent Flyer Airline",
  dateOfBirth: "Date Of Birth",
  infant: "Infant",
  phone: "Phone",
  title: "Title",
  noLuggageIncluded: "No Luggage Included",
  includesLuggage: "Includes Luggage",
  outboundFlight: "Outbound Flight",
  inboundFlight: "Inbound Flight",
  flightNumber: "Flight Number",
  flightNumbers: "Flight Numbers",
  cabinClassType: "Cabin Class Type",
  class: "Class",
  aircraft: "Aircraft",
  aircraftType: "Aircraft Type",
  airlineName: "Airline Name",
  no: "No",
  yes: "Yes",
  anyFlights: "Any Flights",
  oneStop: "One Stop",
  direct: "Direct",
  directFlights: "Direct Flights",
  all: "All",
  first: "First",
  premiumEconomy: "Prem. Economy",
  withBaggageOnly: "With Baggage Only",
  oneWay: "One Way",
  roundTrip: "Round Trip",
  withBaggage: "With Baggage",
  noBaggagePreference: "No Baggage Preference",
  noBaggage: "No Baggage",
  requiredFields: "Required Fields",
  nonRequiredFields: "Non Required Fields",
  cabinClass: "Cabin Class",
  brandName: "Brand Name",
  performNewSearch: "Perform a new search",
  outboundDeparture: "Outbound Departure",
  inboundDeparture: "Inbound Departure",
  created: "Created",
  freeCancellationAvailable: "Free Cancellation Available",
  freeCancellationDeadline: "Free Cancellation Deadline",
  externalReference: "External Reference",
  outboundflightNumber: "Outbound Flight Number",
  inboundflightNumber: "Inbound Flight Number",
  arrival: "Arrival",
  originAirport: "Origin Airport",
};

export default flights;
